import styled, { css } from 'styled-components';
import { animateIn } from '../../utils';

export const Wrapper = styled.article`
	${props =>
		props.gradient &&
		css`
			background: linear-gradient(
				180deg,
				rgba(0, 0, 0, 1) 0%,
				rgba(0, 0, 0, 0.738) 19%,
				rgba(0, 0, 0, 0.541) 34%,
				rgba(0, 0, 0, 0.382) 47%,
				rgba(0, 0, 0, 0.278) 57%,
				rgba(0, 0, 0, 0.194) 65%,
				rgba(0, 0, 0, 0.126) 73%,
				rgba(0, 0, 0, 0.075) 80%,
				rgba(0, 0, 0, 0.038) 88%,
				rgba(0, 0, 0, 0.013) 94%,
				rgba(0, 0, 0, 0) 100%
			);
		`}
	.content {
		padding: var(--containerPadding);
		max-width: 650px;
		margin: auto;
	}

	li {
		margin: inherit;
	}
`;

export const Body = styled.div`
	p:first-child:first-letter {
		font: normal 5rem var(--serif);
		float: left;
		margin: var(--lineHeight) var(--lineHeight) 0 0;
		line-height: 0.65;
	}
`;

export const Facts = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export const Content = styled.div`
	position: relative;
	${animateIn('0.1s')}/* Fades in almost instantly */
`;
